<template>
  <div>
    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box" v-if="service">
          <admin-box-item :title="`[${service.service_name}] 서비스 메뉴 관리`">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="메뉴종류">
                  <lp-radio :val="user_type"
                            value_name="value"
                            label_name="label"
                            :data="userArr"
                            @onSelect="selectUserType"></lp-radio>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full" style="height: calc(100vh - 250px);">
        <div class="editor-wrapper">
          <textarea ref="editorTemplate"></textarea>
        </div>
      </div>

      <!--<div class="column is-full">
        <div class="box">
          &lt;!&ndash; 1차 &ndash;&gt;
          <div v-for="(menu,idx) in menus" :key="'menu-'+idx" class="lp-box">
            <admin-box-item :title="menu.name">
              <div class="flex space-between align-center lp-table-row" style="position:relative">
                <div style="width:85%">
                  <div class="flex-align lp-menu-div">
                    <div class="col-3">메뉴명</div>
                    <input class="input" :value="menu.name"
                           @input="e => menu.name = e.target.value"
                           placeholder="메뉴명을 입력해주세요." type="text">
                  </div>
                  <div class="flex-align lp-menu-div">
                    <div class="col-3">경로</div>
                    <input class="input" :value="menu.path"
                           @input="e => menu.path = e.target.value"
                           placeholder="경로를 입력해주세요." type="text"></div>
                  <div class="flex-align lp-menu-div">
                    <div class="col-3">고유한 메뉴 id</div>
                    <input class="input" :value="menu.menu_id"
                           @input="e => menu.menu_id = e.target.value"
                           placeholder="경로를 입력해주세요." type="text"></div>
                  <div class="flex-align lp-menu-div" v-if="menu.path">
                    <div class="col-3">설명</div>
                    <input class="input" :value="menu.desc"
                           @input="e => menu.desc = e.target.value"
                           placeholder="경로를 입력해주세요." type="text"></div>
                </div>
                <div style="text-align: center">
                  <div>
                    <toggle-button @change="e => menu.enable = e.value"
                                 :value="menu.enable"
                                 :sync="true"
                                 class="changed-font"
                                 :width="70"
                                 :height="24"
                                 :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                  </div>
                  <div>
                    <button class="button is-danger half" style="margin-top:8px" @click="deleteMenu(menus, idx)">삭제</button>
                  </div>
                </div>
                <div class="unselect add-category" style="left:35%" @click="addCategory">1차 카테고리 생성</div>
                <div class="unselect add-category" style="left:55%" @click="addSubCategory(menu)">하위 카테고리 생성</div>
              </div>
              <div v-if="menu.enable">
                &lt;!&ndash; 2차 &ndash;&gt;
                <div v-for="(child,child_idx) in menu.child" :key="'child-'+child_idx">
                  <div class="flex space-between align-center lp-table-row" style="position: relative">
                    <div style="width:80%;margin-left:40px">
                      <div class="flex-align lp-menu-div">
                        <div class="col-3">메뉴명</div>
                        <input class="input" :value="child.name"
                               @input="e => child.name = e.target.value"
                               placeholder="메뉴명을 입력해주세요." type="text">
                      </div>
                      <div class="flex-align lp-menu-div">
                        <div class="col-3">경로</div>
                        <input class="input" :value="child.path"
                               @input="e => child.path = e.target.value"
                               placeholder="경로를 입력해주세요." type="text"></div>
                      <div class="flex-align lp-menu-div">
                        <div class="col-3">고유한 메뉴 id</div>
                        <input class="input" :value="child.menu_id"
                               @input="e => child.menu_id = e.target.value"
                               placeholder="경로를 입력해주세요." type="text"></div>
                      <div class="flex-align lp-menu-div" v-if="child.path">
                        <div class="col-3">설명</div>
                        <input class="input" :value="child.desc"
                               @input="e => child.desc = e.target.value"
                               placeholder="경로를 입력해주세요." type="text"></div>
                    </div>
                    <div style="text-align: center">
                      <div>
                        <toggle-button @change="e => child.enable = e.value"
                                     :value="child.enable"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                      </div>
                      <div>
                        <button class="button is-danger half" style="margin-top:8px" @click="deleteMenu(menu.child, child_idx)">삭제</button>
                      </div>
                    </div>
                    <div class="unselect add-category" style="left:55%" @click="addSubCategory(child)">하위 카테고리 생성</div>
                  </div>
                  &lt;!&ndash; 3차 &ndash;&gt;
                  <div v-if="child.enable">
                    <div v-for="(gchild, gchild_idx) in child.child" :key="'gchild-'+gchild_idx">
                      <div class="flex space-between align-center lp-table-row">
                        <div style="width:78%;margin-left:60px">
                          <div class="flex-align lp-menu-div">
                            <div class="col-3">메뉴명</div>
                            <input class="input" :value="gchild.name"
                                   @input="e => gchild.name = e.target.value"
                                   placeholder="메뉴명을 입력해주세요." type="text">
                          </div>
                          <div class="flex-align lp-menu-div">
                            <div class="col-3">경로</div>
                            <input class="input" :value="gchild.path"
                                   @input="e => gchild.path = e.target.value"
                                   placeholder="경로를 입력해주세요." type="text"></div>
                          <div class="flex-align lp-menu-div">
                            <div class="col-3">고유한 메뉴 id</div>
                            <input class="input" :value="gchild.menu_id"
                                   @input="e => gchild.menu_id = e.target.value"
                                   placeholder="경로를 입력해주세요." type="text"></div>
                          <div class="flex-align lp-menu-div" v-if="gchild.path">
                            <div class="col-3">설명</div>
                            <input class="input" :value="gchild.desc"
                                   @input="e => gchild.desc = e.target.value"
                                   placeholder="경로를 입력해주세요." type="text"></div>
                        </div>
                        <div style="text-align: center">
                          <div>
                            <toggle-button @change="e => gchild.enable = e.value"
                                           :value="gchild.enable"
                                           :sync="true"
                                           class="changed-font"
                                           :width="70"
                                           :height="24"
                                           :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                          </div>
                          <div>
                            <button class="button is-danger half" style="margin-top:8px" @click="deleteMenu(child.child, gchild_idx)">삭제</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    components: {
      LpRadio},
    name: "service-menu",
    data() {
      return {
        editor: undefined,
        // 서비스 메뉴
        menus: [],
        service: undefined,
        user_type: 'admin',
        userArr: [
          {label:'관리자', value:'admin'},
          {label:'파트너', value:'partner'},
          {label:'슈퍼파트너', value:'superpartner'}
        ],
        init_first: true
      }
    },
    watch: {
      user_type (n) {
        this.getMenus();
      }
    },
    created() {
      if(this.$route.query.id) {
        this.$axios.get(`admin/launchpack/service/${this.$route.query.id}`).then(res=> {
          this.service = res.data;
        })
      }

      this.getMenus();
    },
    methods: {
      initCodeEditor (ref) {
        if(this.init_first) {
          this.editor = window.ace.edit(ref);
          this.editor.setTheme("ace/theme/monokai");
          this.editor.session.setMode("ace/mode/json");
          this.editor.setOptions({
            enableBasicAutocompletion: true,
            enableSnippets: true,
            enableLiveAutocompletion: true,
            tabSize: 2,
            newLineMode: 'unix',
            fontSize: '13px'
          });
          this.init_first = false;
        }
        this.editor.setValue(JSON.stringify(this.menus, null, 2));
      },
      saveData () {
        let menus = JSON.parse(this.editor.getValue());
        let params = {
          user_type: this.user_type,
          menus: menus
        };
        this.$axios.post(`admin/launchpack/service/${this.$route.query.id}/menu`, params).then(res => {
          if(res.status===200) {
            this.toast('메뉴가 저장되었습니다')
          }
        })
      },
      deleteMenu(menus, idx) {
        removeIndex(menus,idx);
      },
      // 1차 카테고리 추가
      addCategory () {
        this.menus.push({
          enable: true,
          desc: "",
          img: "",
          menu_id: "",
          name: "",
          path: "",
          child: []
        })
      },
      // 하위 카테고리 추가
      addSubCategory (menu) {
        menu.child.push({
          enable: true,
          desc: "",
          img: "",
          menu_id: "",
          name: "",
          path: "",
          child: []
        })
      },
      getMenus() {
        this.$axios.get(`admin/launchpack/service/${this.$route.query.id}/menu?user_type=${this.user_type}`).then(res=> {
          let menus = res.data;
          // this.setMenus(menus);
          this.menus = this.cloneItem(menus);
          this.initCodeEditor(this.$refs.editorTemplate);
        })
      },
      setMenus (menus) {
        menus.forEach(menu=> {
          if(!menu.child) {
            menu['child'] = [];
          }
        });
        for(let i=0; i<menus.length; i++) {
          // enable 없다면 추가
          if(Object.keys(menus[i]).indexOf('enable')===-1) {
            menus[i].enable = true;
          }
          let child = menus[i].child;
          if(Object.keys(menus[i]).indexOf('child')===-1) continue;
          else if(child.length>0) this.setMenus(child);
        }
      },
      selectUserType(val) {
        this.user_type=val;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .lp-table-row
    padding 6px 0
    border-bottom 1px solid rgb(152, 152, 152)

  .lp-menu-div
    margin-bottom: 8px

  .lp-table-row:hover .add-category
    display block

  .add-category
    display none
    position absolute
    bottom -14px
    transform translate(-50%, 0)
    background-color #eee
    padding 4px 8px
    border-radius 8px
    z-index 10

  .lp-box
    margin-top 12px

  .lp-box:first-child
    margin-top 0
</style>
<style lang="stylus">
  .editor-wrapper
    width 100%
    height calc(100% - 58px)
    background-color rgba(60, 60, 60, .5)

  .ace_editor
    margin 0
    height 100%

  .modal-page-prop .sweet-modal
    max-width 1000px

  .editor-container .sweet-modal
    top 44%
</style>
